import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Meta from '../../../components/Meta';
import { SUPPORT_EMAIL } from '../../../constants/constants';

const PriceGuide = () => {
  return (
    <>
    <Meta>
        title='料金・支払方法について | ふるぷら'
        description='ふるぷらの料金・支払方法について説明するページです。'
        keywords={['ふるぷら', '古着', '料金', 'レンタルプラン']}
    </Meta>
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={8} lg={5}>
          <section className='PriceGuideToppage'>  
            <h1 className="fs-3 mb-4 text-center">料金支払い方法について</h1>
              <h2 className='fs-5 fw-bold'>レンタルのプランについて</h2>
                <h3 className='fs-6 fw-bold text-info'>単発レンタル</h3>
                  <p>
                    3泊4日 - 定価の40％<br />
                    2週間 - 定価の50％<br />
                    1カ月 - 定価の60％<br />
                  </p>
                <h3 className='fs-6 fw-bold text-info'>サブスク</h3>
                  <p>
                    LightPlan 【7000円(税込)以下の服が1着借り放題】- ¥3,980<br />
                    StandardPlan【12000円(税込)以下の服が1着借り放題】 - ¥5,980<br />
                    PremiumPlan【20000円(税込)以下の服が1着借り放題】 - ¥9,980<br />
                  </p>
                  <br />
              <h2 className='fs-5 fw-bold'>レンタル中の購入金額</h2>
                <p>レンタル中に購入される場合は、定価の10％引きで購入することが可能です。</p><br />
              <h2 className='fs-5 fw-bold'>支払方法</h2>
                <p>現在使用できる決済手段は、クレジットカードのみとなっております。<br />
                   今後、コンビニ決済等その他の決済手段も対応予定です。今しばらくお待ちください。<br />
                </p>
                <br />
              <h2 className='fs-5 fw-bold'>遅延・破損・紛失した場合のお支払について</h2>
                <h3 className='fs-6 fw-bold text-info'>単発レンタルご利用時にレンタル返却予定日を過ぎた場合</h3>
                  <p>
                    レンタルの返却予定日を過ぎてのご返却を希望される場合は、ふるぷら公式ECサイト上で<span className='fw-bold text-danger'>必ずお手続き</span>をしてください。<br />
                    <br />
                    <h4 className='fs-9 fw-bold text-warning'>レンタル期限延長の方法</h4>
                    1．サイト上部のサイトバーから👤＞＞【注文履歴】＞＞【返却期限が近い商品】＞＞該当商品の【確認をする】をクリックしてください。<br />
                    2．【レンタル期限を延長する】をクリックし、ご所望のレンタル延長期限(3日あるいは1週間)を選択してください。<br />
                    3．【延長をする】をクリックすると、延長手続きが完了します。<br />
                    <br />
                    <h4 className='fs-9 fw-bold text-warning'>レンタル期限延長の追加料金</h4>
                    3日延長：商品の定価10％<br />
                    1週間延長：商品の定価20％<br />
                    無断延長：1回につき、商品の定価30％をお支払いただき、レンタル返却期限が1週間、自動延長されます。<br />
                    レンタル期間が3回自動延長された場合は、<span className='fw-bold text-danger'>紛失時の対応と同様に扱い、</span>更に商品の定価90％をお支払いただきます。<br />
                  </p>
                <h3 className='fs-6 fw-bold text-info'>破損をした場合</h3>
                    <p>
                    レンタル中に破損をしてしまった場合には、商品の価格からレンタル代を引いたものを破損補償として、お支払いただきます。<br />
                    破損をしてしまった場合は、<br />
                    <a
                        href={`mailto:${SUPPORT_EMAIL}`}
                        style={{ marginLeft: '0.5rem', color: '#0070f3' }}
                    >
                        {SUPPORT_EMAIL}
                    </a> 
                    までご連絡ください。 <br />
                    破損に関するご連絡がなく、返却後に大きな破損が発覚した際には、次回以降のレンタルができない可能性があります。<br />
                    ご了承ください。<br />
                    </p>
                <h3 className='fs-6 fw-bold text-info'>紛失した場合</h3>
                  紛失をした際には、<br />
                    <a
                        href={`mailto:${SUPPORT_EMAIL}`}
                        style={{ marginLeft: '0.5rem', color: '#0070f3' }}
                    >
                        {SUPPORT_EMAIL}
                    </a> 
                    までご連絡ください。 <br />
                  追加料金として、商品の定価90％をお支払いただきます。
          </section>
        </Col>
      </Row>
    </Container>
    </>
  )
}

export default PriceGuide